/**
 * workflow-core
 *
 * Copyright (c) Ballerine
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */
import '../check-is-iso-date/check-is-iso-date.js';
import '../collection-flow/validators/index.js';
import '../collection-flow/schemas/config-schema.js';
import '../../consts/index.js';
import { isType } from '../is-type/is-type.js';
import 'crypto-js';
import '../value-or-na/value-or-na.js';
import { z } from 'zod';
import '../../countries/index.js';
import '../countries-data-shared/countries-data-shared.js';

var checkIsUrl = isType(z.string().url());

export { checkIsUrl };
//# sourceMappingURL=check-is-url.js.map
